import React from "react";
import { Navigate } from "react-router";
import Base from "./Base";
import DatePicker from 'react-datepicker2';
import SelectAsync from "react-select/async";
import PersonCard from "./Accountings/PersonCard";
import PracticalTexts from "./PracticalTexts";

export default class Meeting extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            refreshCallerAfterSave: this.isNull(props.RefreshCallerAfterSave) ? true : props.RefreshCallerAfterSave,
            readOnly: this.isNull(props.ReadOnly) ? true : props.ReadOnly,
            caller: props.Caller,
            data: null,
            loading: true,
            previousMeetingId: props.previousMeetingId,
            time: "",
            inputTime: "",
            initPerson: this.isNull(props.InitPerson) ? null : props.InitPerson,
            messageTemplateId: this.getDefaultGuid(),
            templates: [],
            personIdToDisplayCard: null,
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();

        var p1 = this.httpPost("api/v1/common/getsmstemplate", {
            onlySystemTemplates: false,
            useIn: 'meeting'
        })
            .then(data => {
                this.state.templates = data.templates;
            });

        var p2 = this.httpPost("api/v1/meeting/get", {
            id: this.getCurrentFormId(),
        }).then((data) => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.state.data = data;
                this.state.time = data.record.time;
                this.state.inputTime = data.record.time != 0 ? this.formatTimeForInput(data.record.time.toString()) : "";

                if (this.state.id === this.getDefaultGuid()) {
                    if (!this.isNull(this.state.initPerson)) {
                        this.state.data.record.members.push({
                            value: this.state.initPerson.id,
                            label: this.state.initPerson.name
                        });
                    }
                }
            }
        });
        Promise.all([p1, p2]).then((r) => {
            this.setState({
                loading: false,
            });
        });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();

        this.httpPost("api/v1/meeting/save", {
            id: this.state.id,
            subject: this.state.data.record.subject,
            meetingResultId: this.state.data.record.meetingResultId,
            date: this.convertMomentToDb(this.state.data.record.date),
            time: this.state.time != "" ? parseInt(this.state.time) : 0,
            userId: this.state.data.global.user.id,
            previousMeetingId: this.state.previousMeetingId == this.defaultGuid() ? this.state.data.record.previousMeetingId : this.state.previousMeetingId,
            resultText: this.state.data.record.resultText,
            agendaText: this.state.data.record.agendaText,
            meetingStatus: this.state.data.record.meetingStatus,
            address: this.state.data.record.address,
            type: this.state.data.record.type,
            members: this.state.data.record.members,
            managers: this.state.data.record.managers,
            messageTemplateId: this.state.messageTemplateId,
        }).then((data) => {
            if (data.status === -1) window.location.href = "/login";
            this.state.innerStatus = data.innerStatus;
            if (data.status === 1) {
                this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                if (this.state.refreshCallerAfterSave)
                    this.state.caller.refreshData();
                this.closeMe();
            } else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false,
                });
            }
        });
    }
    formatTimeForInput = (timeString) => {
        if (timeString.length === 5)
            timeString = "0" + timeString;
        if (timeString.length === 6) {
            return `${timeString.slice(0, 2)}:${timeString.slice(2, 4)}:${timeString.slice(4, 6)}`;
        }
        return "";
    }
    validateTime = (timeString) => {
        if (!/^\d{6}$/.test(timeString)) return "فرمت ساعت نادرست است!";

        const hours = parseInt(timeString.slice(0, 2), 10);
        const minutes = parseInt(timeString.slice(2, 4), 10);
        const seconds = parseInt(timeString.slice(4, 6), 10);

        if (hours < 0 || hours > 23) return "ساعت باید بین 00 تا 23 باشد!";
        if (minutes < 0 || minutes > 59) return "دقیقه باید بین 00 تا 59 باشد!";
        if (seconds < 0 || seconds > 59) return "ثانیه باید بین 00 تا 59 باشد!";

        return "";
    }
    handleTimeChange = (e) => {
        const value = e.target.value; // مقدار ورودی در فرمت HH:mm:ss
        if (value) {
            const formattedTime = value.replace(/:/g, ""); // حذف دو نقطه
            var resValidate = this.validateTime(formattedTime);
            if (resValidate) {
                this.showErorrMessage(resValidate);
                return;
            }
            this.setState({
                time: formattedTime,
                inputTime: value
            });
        } else {
            this.setState({
                time: ""
            });
        }
    }
    setMembers(e) {
        this.state.data.record.members = e;
    }
    setManagers(e) {
        this.state.data.record.managers = e;
    }    
    selectSubject() {
        this.removeKeyDown();
        this.showComponents({
            component: (
                <PracticalTexts
                    Caller={this}
                    Type={1}
                    OnSelect="onSelectSubject"
                />
            ),
        });
        
    }
    onSelectSubject(e) {
        this.state.data.record.subject = e.text;
        this.setState({ data: this.state.data });
    }
    selectAgendaText() {
        this.removeKeyDown();
        this.showComponents({
            component: (
                <PracticalTexts
                    Caller={this}
                    Type={2}
                    OnSelect="onSelectAgendaText"
                />
            ),
        });

    }
    onSelectAgendaText(e) {
        this.state.data.record.agendaText = e.text;
        this.setState({ data: this.state.data });
    }
    selectResultText() {
        this.removeKeyDown();
        this.showComponents({
            component: (
                <PracticalTexts
                    Caller={this}
                    Type={3}
                    OnSelect="onSelectResultText"
                />
            ),
        });

    }
    onSelectResultText(e) {
        this.state.data.record.resultText = e.text;
        this.setState({ data: this.state.data });
    }
    setMeetingResult(e) {
        this.state.data.record.meetingResultId = e.value;
        this.state.data.record.meetingResultString = e.label;
    }
    renderForm() {
        return (
            <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
                <div className="modal-backdrop fade in" style={{ height: "100%" }} onClick={(e) => this.closeMe()}></div>
                <div className="modal-dialog ui-draggable" style={{ minWidth: "90%" }}>
                    <div className="modal-content">
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={(e) => this.closeMe()} aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                            {!this.state.readOnly && <h4 className="modal-title">
                                {this.state.data.record.id !== this.getDefaultGuid() ? "ویرایش اطلاعات جلسه" : "افزودن جلسه"}
                            </h4>}
                            {this.state.readOnly && <h4 className="modal-title">
                                محتوای جلسه
                            </h4>}
                        </div>
                        <div className="modal-body" >
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="form-group" key={this.state.data.record.subject }>
                                            <label htmlFor="subject" className="title1">
                                                {!this.state.readOnly && <a onClick={e => this.selectSubject()} title="درج متن آماده"><em className="icon ni ni-property-add text-primary"></em></a>}موضوع :</label>
                                            {this.state.readOnly ? <p>{this.state.data.record.subject}</p>
                                                :
                                                <input
                                                    defaultValue={this.state.data.record.subject}
                                                    autoComplete="off"
                                                    onChange={(e) => (this.state.data.record.subject = e.target.value)}
                                                    type="text"
                                                    className="form-control input-sm"
                                                />
                                            }
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label htmlFor="meetingStatus" className="title1">وضعیت:</label>
                                            {this.state.readOnly ? <p>{this.state.data.record.meetingStatusString}</p>
                                                :
                                                <select
                                                    defaultValue={this.state.data.record.meetingStatus}
                                                    onChange={(e) => (this.state.data.record.meetingStatus = parseInt(e.target.value))}
                                                    className="form-control text-center"
                                                >
                                                    <option value="1">باز</option>
                                                    <option value="2">برگزار شده</option>
                                                    <option value="3">کنسل شده</option>
                                                    <option value="4">عدم حضور</option>
                                                    <option value="5">بسته شد</option>
                                                </select>
                                            }
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label htmlFor="meetingDate" className="title1">تاریخ برگزاری :</label>
                                            {this.state.readOnly ? <p>{this.state.data.record.dateString}</p>
                                                :
                                                <DatePicker
                                                    inputReadOnly={false}
                                                    className="form-control persian-date ltr"
                                                    placeholder={"تاریخ"}
                                                    isGregorian={false}
                                                    showTodayButton={true}
                                                    timePicker={false}
                                                    onChange={(e) => { this.state.data.record.date = e }}
                                                    value={this.getFormatedDateForDatePicker(this.state.data.record.date)}
                                                />
                                            }
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label htmlFor="meetingTime" className="title1">ساعت جلسه:</label>
                                            {this.state.readOnly ? <p>{this.state.inputTime}</p>
                                                :
                                                <input
                                                    type="time"
                                                    value={this.state.inputTime}
                                                    onChange={e => this.handleTimeChange(e)}
                                                    className="form-control input-sm"
                                                    step="1"
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    {!this.state.readOnly && <div className="col-sm-2">
                                        <div className="form-group">
                                            <label for="name" className="title1">پیامک</label>
                                            <select defaultValue={this.state.messageTemplateId} onChange={e => this.state.messageTemplateId = e.target.value} autocomplete="off" type="text" className="form-control input-sm">
                                                <option value={this.getDefaultGuid()}>انتخاب نمایید</option>
                                                {this.state.templates.map(template =>
                                                    <option value={template.id}>{template.title}</option>
                                                )}
                                            </select>
                                        </div>
                                    </div>}
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label htmlFor="meetingStatus" className="title1">نحوه برگزاری:</label>
                                            {this.state.readOnly ? <p>{this.state.data.record.typeString}</p>
                                                :
                                                <select
                                                    defaultValue={this.state.data.record.type}
                                                    onChange={(e) => (this.state.data.record.type = parseInt(e.target.value))}
                                                    className="form-control text-center"
                                                >
                                                    <option value="3">حضوری/آنلاین</option>
                                                    <option value="1">حضوری</option>
                                                    <option value="2">آنلاین</option>
                                                </select>
                                            }
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label htmlFor="meetingStatus" className="title1">نتیجه جلسه:</label>
                                            {this.state.readOnly ? <p>{this.state.data.record.meetingResultString}</p>
                                            :
                                            <SelectAsync
                                                style={{ width: "100%" }}
                                                defaultValue={
                                                    this.state.data.record.meetingResultId !=
                                                        this.getDefaultGuid()
                                                        ? [
                                                            {
                                                                value: this.state.data.record.meetingResultId,
                                                                label:
                                                                    this.state.data.record.meetingResultString,
                                                            },
                                                        ]
                                                        : null
                                                }
                                                isMulti={false}
                                                placeholder="انتخاب نتیجه"
                                                defaultOptions
                                                loadOptions={(inputValue, callback) => this.loadMeetingResualtOptions(inputValue, callback,0)}
                                                onChange={(e) => this.setMeetingResult(e)}
                                            />
                                            }
                                        </div>
                                    </div>                                    
                                    <div className="col-sm-6">
                                        <div className="form-group">
                                            <label htmlFor="address" className="title1">محل برگزاری :</label>
                                            {this.state.readOnly ? <p>{this.state.data.record.address}</p>
                                                :
                                                <input
                                                    defaultValue={this.state.data.record.address}
                                                    autoComplete="off"
                                                    onChange={(e) => (this.state.data.record.address = e.target.value)}
                                                    type="text"
                                                    className="form-control input-sm"
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="form-group" key={this.state.data.record.agendaText }>
                                            <label htmlFor="agendaText" className="title1">{!this.state.readOnly && <a onClick={e => this.selectAgendaText()} title="درج متن آماده"><em className="icon ni ni-property-add text-primary"></em></a>}دستور جلسه :</label>
                                            {this.state.readOnly ? <div dangerouslySetInnerHTML={{ __html: this.convertNewLines(this.state.data.record.agendaText) }}></div>
                                                :
                                                <textarea style={{ "minHeight": "120px" }} defaultValue={this.state.data.record.agendaText} onChange={e => this.state.data.record.agendaText = e.target.value} autocomplete="off" type="text" className="form-control input-sm"></textarea>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="form-group" key={this.state.data.record.resultText }>
                                            <label htmlFor="resultText" className="title1">{!this.state.readOnly && <a onClick={e => this.selectResultText()} title="درج متن آماده"><em className="icon ni ni-property-add text-primary"></em></a>}تصمیمات و نتایج:</label>
                                            {this.state.readOnly ? <div dangerouslySetInnerHTML={{ __html: this.convertNewLines(this.state.data.record.resultText) }}></div>
                                                :
                                                <textarea style={{ "minHeight": "120px" }} defaultValue={this.state.data.record.resultText} onChange={e => this.state.data.record.resultText = e.target.value} autocomplete="off" type="text" className="form-control input-sm"></textarea>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="subject" className="title1">
                                                مدیران جلسه :
                                            </label>
                                            <div className="form-control-wrap">
                                                {this.state.readOnly ? <p>
                                                    {this.state.data.record.managers.map(f =>
                                                        <span onClick={e => this.setState({ personIdToDisplayCard: f.value })} className="hand" style={{ "background-color": "#dbdfea", "padding": "0 5px", "margin-left": "5px", "border-radius": "5px", "margin-bottom": "15px", "display": "inline-block" }}>{f.label}</span>
                                                    )}
                                                </p>
                                                    :
                                                    <SelectAsync
                                                        defaultValue={this.state.data.record.managers}
                                                        isMulti={true}
                                                        placeholder="انتخاب مدیران جلسه"
                                                        defaultOptions
                                                        loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback,0 , 3)}
                                                        onChange={(e) => this.setManagers(e)}
                                                    />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="subject" className="title1">
                                                اعضای جلسه :
                                            </label>
                                            <div className="form-control-wrap">
                                                {this.state.readOnly ? <p>
                                                    {this.state.data.record.members.map(f =>
                                                        <span onClick={e => this.setState({ personIdToDisplayCard : f.value})} className="hand" style={{ "background-color": "#dbdfea", "padding": "0 5px", "margin-left": "5px", "border-radius": "5px", "margin-bottom": "15px", "display": "inline-block" }}>{f.label}</span>
                                                    )}
                                                </p>
                                                    :
                                                    <SelectAsync
                                                        defaultValue={this.state.data.record.members}
                                                        isMulti={true}
                                                        placeholder="انتخاب اعضای جلسه"
                                                        defaultOptions
                                                        loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 0, 0)}
                                                        onChange={(e) => this.setMembers(e)}
                                                    />
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {this.state.personIdToDisplayCard != null && <div className="row" key={this.state.personIdToDisplayCard}>
                                    <div className="col-sm-12">
                                        <PersonCard PersonId={this.state.personIdToDisplayCard} Inline={true} />
                                    </div>
                                </div>}                              
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default btn-smoke" onClick={(e) => this.closeMe()}>انصراف</button>
                            {!this.state.readOnly && <button type="submit" name="bank_form_modal_submit" className="btn btn-success" onClick={e => this.save(e)}>ذخیره</button>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    render() {
        if (!this.isBlank(this.state.redirect))
            return <Navigate to={this.state.redirect} />;

        let contents = this.state.loading
            ? this.renderLoading()
            : [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent()
            ];

        return contents;
    }
}